import { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/ui/tooltip";
import { cn } from "@/shared/lib/utils";

type Props = {
  show: boolean;
  message: string;
  children: ReactNode;
  className?: string;
};

/**
 * Wraps an action control and, when `show` is true, surfaces a tooltip with
 * `message`. The control is wrapped in a span so disabled buttons still emit
 * the hover events the tooltip relies on. When `show` is false the children
 * are rendered bare.
 */
export const DisabledActionTooltip = ({
  show,
  message,
  children,
  className,
}: Props) => {
  if (!show) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn("inline-flex", className)}>{children}</span>
        </TooltipTrigger>
        <TooltipContent>{message}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
